import { Link, useParams } from 'react-router-dom';
import { BottomNavbar, Footer, Hero, Navbar, ProductCard } from '../components'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Grid from '@mui/material/Grid'
import heContent from "../languages/hebrew.json"
import arContent from "../languages/arabic.json"
import { getCategorySlug } from '../utils/Utils';

const Products = ({ endPoint }) => {

    const {categoryName} = useParams();
      // NEW Patch: Fix manual URL entry for share url / Check Cagtegory language
    const isArabicCategory = arContent.categories.some(cat => getCategorySlug(cat.name) === categoryName);
    const contentLng = isArabicCategory ? arContent : heContent;

    const category = contentLng.categories.find((cat) => getCategorySlug(cat.name) === categoryName);
    if (!category) {
        return <div style={{ padding: 40 }}>⚠️ Category not found: {categoryName}</div>;
    }
    
    // Debug: Check raw imported data - check ALL products, not just index 0
    if (category.name === 'כוסות פלסטיק 🥤') {
        console.log('=== RAW IMPORT DEBUG ===');
        console.log('Total products in category:', category.products.length);
        console.log('First product name:', category.products[0]?.name);
        console.log('First product picture:', category.products[0]?.picture);
        console.log('Product with name "כוס קרסטל 250":', category.products.find(p => p.name === 'כוס קרסטל 250'));
        console.log('Product with name "כוס לונגים":', category.products.find(p => p.name === 'כוס לונגים'));
        // Check if heContent itself has the data
        console.log('heContent categories[0] products[0]:', heContent.categories[0]?.products[0]);
    }
    
    // Filter out empty/invalid products - pass products directly like ProductsArea does
    const products = category.products.filter(product => product && product.name && typeof product === 'object');

    return (

        <div className='Product'>
            <Navbar endPoint={endPoint} />
            <Hero heroBg={`/categories/${category.image}`} mt='0px' textInHero={category.name} endPoint={endPoint} />
            <div className="product-data" style={{ marginTop: '25px', minHeight: '80vh' }}>
                <Link to={`/`}>
                    <button className='showAllBtn' style={backBtn}><ArrowForwardIosIcon />{contentLng.backBtn}</button>
                </Link>
                <Grid container className='zaza'>
                    {products.map((product, i) => {
                        const productId = product.sku || i;
                        return (
                        <Grid item md={4} lg={3} key={i} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            {/* Each Product In The Above Category */}
                            <Link to={`/${getCategorySlug(category.name)}/${productId}`}>
                                <ProductCard product={product} endPoint={endPoint} wspDetails={''} />
                            </Link>

                        </Grid>
                    )})}
                </Grid>
                <div style={{ margin: '20px', width: '100vw' }}>
                    <Link to={`/`}>
                        <button className='showAllBtn' style={backBtn}><ArrowForwardIosIcon />{contentLng.backBtn}</button>
                    </Link>
                </div>
            </div>
            <Footer contentLng={contentLng} />
            <BottomNavbar />
        </div>

    )
}

const backBtn = {
    margin: '30px 15px',
    width: '70px',
    justifyContent: 'center',
    alignItems: 'Center',
    height: '30px',
    borderRadius: '15px',
    padding: '3px 10px',
}

export default Products